import { CreateVideo, HomepageVideo } from "../types/working-model";
import { Get, Post, Put } from "./helpers";

export function GetVideos(token: string, channel: number): Promise<any> {
	return Get(`/v3/admin/channel/videos/${channel}`, token);
}

export function InsertVideo(token: string, video: CreateVideo): Promise<any> {
	return Post(`/v3/admin/channel/videos`, token, video);
}

export function UpdateVideo(token: string, video: HomepageVideo): Promise<any> {
	return Put(`/v3/admin/channel/videos`, token, video);
}

export function UploadedVideo(token: string, video: CreateVideo): Promise<any> {
	return Post('/v3/admin/channel/videos/uploaded', token, video);
}

export function GetChannelVideos(token: string, channel: number): Promise<HomepageVideo[]> {
	return Get(`/v3/admin/channel/videos/channel/${channel}`, token);
}

export function GetIbmDownloadLink(token: string, video_id: string): Promise<any> {
	return Get(`/v3/admin/channel/videos/ibm/download/${video_id}`, token);
}

export function GetWistiaDownloadLink(token: string, hashed_id: string): Promise<any> {
	return Get(`/v3/admin/channel/videos/wistia/download/${hashed_id}`, token);
}

export function GetRecordedVideos(token: string, channel: number): Promise<any> {
	return Get(`/v3/admin/channel/videos/recorded/${channel}`, token);
}

export function GetRecordedVideoDownload(token: string, stream_recording: string): Promise<any> {
	return Get(`/v3/admin/channel/videos/recorded/download/${stream_recording}`, token);
}

export function DeleteRecordedVideos(videoIDs: number[], token: string, channel: number): Promise<any> {
	return Post(`/v3/admin/channel/videos/delete-recorded/${channel}`, token, { videoIDs });
}

export function DeleteUploadedVideos(videoIDs: number[], token: string, channel: number): Promise<any> {
	return Post(`/v3/admin/channel/videos/delete-uploaded/${channel}`, token, { videoIDs });
}
